// A category's pot flag (finance-real round 8, slice 9 J41), on Add category and in a category's drawer in Setup.
// While a cost, a contract line or a month of the ads feed comes out of the pot, the box stays ticked and locked and says
// why: the server refuses turning it off then.
import { ENTITY_CONFIG } from "@/core/entityConfig";

const clientWord = ENTITY_CONFIG.client.label.toLowerCase();
const clientsWord = ENTITY_CONFIG.client.plural.toLowerCase();

export const POT_HINT = `BeNerdy pays its bills as one charge for several ${clientsWord} and for itself, like the Meta card. A ${clientWord}'s cost passed along at cost can then come out of it, and Business ${ENTITY_CONFIG.expense.plural.toLowerCase()} shows what went to ${clientsWord} and what is BeNerdy's own.`;

export const POT_LOCKED = "Costs come out of it, so it stays a pot. Take them off their pot first.";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Something comes out of it, so it cannot stop being a pot. */
  locked?: boolean;
  disabled?: boolean;
}

export function PotCheckbox({ checked, onChange, locked = false, disabled = false }: Props) {
  return (
    <label className="flex items-start gap-2 text-sm text-gray-700">
      <input type="checkbox" className="mt-0.5" checked={checked} disabled={disabled || (locked && checked)} onChange={(e) => onChange(e.target.checked)} />
      <span>
        It is a pot
        <span className="block text-xs text-gray-400">{locked && checked ? POT_LOCKED : POT_HINT}</span>
      </span>
    </label>
  );
}
